/**
 * ============================================================================
 * USER / TENANT ROUTES: Workspace Route Definitions
 * ============================================================================
 * Purpose:
 *   Defines routes and element mappings for Tenant Database workspace screens
 *   (Campaigns, Templates, Contacts, Phone Numbers, Ledgers, Messages, Support).
 * ============================================================================
 */

import React from "react";
import { Route } from "react-router-dom";

import CampaignManagement from "../user/pages/campaigns/CampaignManagement";
import CreateCampaign from "../user/pages/campaigns/CreateCampaign";
import GeneralMessages from "../user/pages/messages/GeneralMessages";
import TemplateManagement from "../user/pages/templates/TemplateManagement";
import CreateTemplate from "../user/pages/templates/CreateTemplate";
import ContactManagement from "../user/pages/contacts/ContactManagement";
import PhoneNumberList from "../user/pages/phoneNumbers/PhoneNumberList";
import LedgerManagement from "../user/pages/ledgers/LedgerManagement";
import MessageLogView from "../user/pages/messages/MessageLogView";
import SupportTickets from "../user/pages/tickets/SupportTickets";
import ReportManagement from "../user/pages/reports/ReportManagement";
import ApiDocumentation from "../user/pages/docs/ApiDocumentation";
import TinyUrls from "../user/pages/tinyUrls/TinyUrls";
import TinyUrlAnalytics from "../user/pages/tinyUrls/TinyUrlAnalytics";
import CreateTinyUrl from "../user/pages/tinyUrls/CreateTinyUrl";
import Chat from "../user/pages/chat/Chat";
import IndiaMartIntegration from "../user/pages/integrations/IndiaMartIntegration";

export const userRoutes = (
  <>
    {/* Scoped workspace routes */}
    <Route path="workspace/integrations/indiamart" element={<IndiaMartIntegration />} />
    <Route path="workspace/integrations" element={<IndiaMartIntegration />} />
    <Route path="workspace/indiamart" element={<IndiaMartIntegration />} />
    <Route path="workspace/tiny-urls" element={<TinyUrls />} />
    <Route path="workspace/tiny-urls/create" element={<CreateTinyUrl />} />
    <Route path="workspace/tiny-urls/edit/:id" element={<CreateTinyUrl />} />
    <Route path="workspace/tiny-urls/:id/analytics" element={<TinyUrlAnalytics />} />
    <Route path="workspace/tiny-urls/analytics/:id" element={<TinyUrlAnalytics />} />
    <Route path="workspace/links" element={<TinyUrls />} />
    <Route path="workspace/links/:id/analytics" element={<TinyUrlAnalytics />} />
    <Route path="workspace/docs" element={<ApiDocumentation />} />
    <Route path="workspace/api-docs" element={<ApiDocumentation />} />
    <Route path="workspace/campaigns" element={<CampaignManagement />} />

    <Route path="workspace/campaigns/create" element={<CreateCampaign />} />
    <Route path="workspace/campaigns/edit/:id" element={<CreateCampaign />} />
    <Route path="workspace/general-messages" element={<GeneralMessages />} />
    <Route path="workspace/reports" element={<ReportManagement />} />
    <Route path="workspace/reports/general" element={<ReportManagement defaultTab="general" />} />
    <Route path="workspace/reports/campaigns" element={<ReportManagement defaultTab="campaigns" />} />
    <Route path="workspace/reports/api" element={<ReportManagement defaultTab="api" />} />
    <Route path="workspace/templates" element={<TemplateManagement />} />
    <Route path="workspace/templates/create" element={<CreateTemplate />} />
    <Route path="workspace/templates/edit/:id" element={<CreateTemplate />} />
    <Route path="workspace/contacts" element={<ContactManagement />} />
    <Route path="workspace/groups" element={<ContactManagement defaultTab="groups" />} />
    <Route path="workspace/phone-numbers" element={<PhoneNumberList />} />
    <Route path="workspace/ledgers" element={<LedgerManagement />} />
    <Route path="workspace/messages" element={<MessageLogView />} />
    <Route path="workspace/chat" element={<Chat />} />
    <Route path="workspace/tickets" element={<SupportTickets />} />

    {/* User client routes */}
    <Route path="user/phone-numbers" element={<PhoneNumberList />} />

    {/* Top-level aliases */}
    <Route path="campaigns" element={<CampaignManagement />} />
    <Route path="campaigns/create" element={<CreateCampaign />} />
    <Route path="campaigns/edit/:id" element={<CreateCampaign />} />
    <Route path="general-messages" element={<GeneralMessages />} />
    <Route path="reports" element={<ReportManagement />} />
    <Route path="reports/general" element={<ReportManagement defaultTab="general" />} />
    <Route path="reports/campaigns" element={<ReportManagement defaultTab="campaigns" />} />
    <Route path="reports/api" element={<ReportManagement defaultTab="api" />} />
    <Route path="templates" element={<TemplateManagement />} />
    <Route path="templates/create" element={<CreateTemplate />} />
    <Route path="templates/edit/:id" element={<CreateTemplate />} />
    <Route path="contacts" element={<ContactManagement />} />
    <Route path="groups" element={<ContactManagement defaultTab="groups" />} />
    <Route path="phone-numbers" element={<PhoneNumberList />} />
    <Route path="ledgers" element={<LedgerManagement />} />
    <Route path="messages" element={<MessageLogView />} />
    <Route path="chat" element={<Chat />} />
    <Route path="tickets" element={<SupportTickets />} />
    <Route path="tiny-urls" element={<TinyUrls />} />
    <Route path="tiny-urls/create" element={<CreateTinyUrl />} />
    <Route path="tiny-urls/edit/:id" element={<CreateTinyUrl />} />
    <Route path="tiny-urls/:id/analytics" element={<TinyUrlAnalytics />} />
    <Route path="tiny-urls/analytics/:id" element={<TinyUrlAnalytics />} />
    <Route path="links" element={<TinyUrls />} />
    <Route path="links/:id/analytics" element={<TinyUrlAnalytics />} />
    <Route path="docs" element={<ApiDocumentation />} />
    <Route path="api-docs" element={<ApiDocumentation />} />
    <Route path="documentation" element={<ApiDocumentation />} />
    <Route path="integrations/indiamart" element={<IndiaMartIntegration />} />
    <Route path="integrations" element={<IndiaMartIntegration />} />
    <Route path="indiamart" element={<IndiaMartIntegration />} />
  </>
);


export default userRoutes;
